export default __webpack_public_path__ + "static/media/arctic-fox.d2d3e0c7.png";